import * as styles from "./HelpCardStyles";
import { QuestionCircleOutlined, TeamOutlined } from "@ant-design/icons";
import { Alert } from "antd";

function HelpCard() {
  return (
    <styles.Container>
      <styles.Header>
        <QuestionCircleOutlined className="icon" />
        <h3>Support</h3>
      </styles.Header>
      <styles.Body>
        <div>
          <p>
          We understand that sometimes you may encounter issues or have questions about our products and services, and we are here to assist you in any way we can. Our dedicated support team is available to provide you with quick and efficient solutions to any problems you may encounter.
          </p>
          <p>Whether you need assistance with setting up your account, navigating our website, or resolving technical issues, we have the knowledge and expertise to help you. Our team is committed to delivering outstanding customer service, and we pride ourselves on being responsive, courteous, and knowledgeable.</p>
          <Alert
            description="Note: Don't share the Support code with anyone besides our support team."
            type="warning"
          />
        </div>
        <img src="/Assets/Images/Document.png" alt="doc" />
      </styles.Body>
      <styles.Footer>
        <TeamOutlined className="footerIcon"/>
        <div>
          <h3>support@soterius.com</h3>
          <h5>Our Support Email</h5>
        </div>
      </styles.Footer>
    </styles.Container>
  );
}

export default HelpCard;
